export default "/assets/images/mila-room-showcase-01.6d60b5b6b0cba2a4.webp";